import type { z } from 'zod';

import { institutionDetailsRegulatoryInformationSchema } from '@/services/api/profile';

export const institutionRegulationsSchema = institutionDetailsRegulatoryInformationSchema;

export type InstitutionRegulations = z.infer<typeof institutionDetailsRegulatoryInformationSchema>;

export type InstitutionRegulationsOrDefaults = InstitutionRegulations | Partial<InstitutionRegulations>;
